
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.682 5.193l3.64-3.64 9.183 9.182-3.64 3.64-9.183-9.182zM.144 3.668L3.775.038 4.938 1.2l-3.63 3.631L.143 3.668zm11.099 11.226l3.64-3.714v3.714h-3.64z","fill":"#A8B7C7","fill-rule":"evenodd"}})])
          )
        }
      }
    